import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { formatCurrency } from "../../utils";

// Data untuk chart, disesuaikan agar mirip dengan gambar

// Komponen chart
export const ProfitTrendsChart = ({ dashboard }) => {
  const data = (dashboard?.profit_trends || []).map((item) => ({
    date: new Date(item.date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
    }), // or format if needed
    profit: parseFloat(item.cumulative_profit_usdt),
  }));
  return (
    <div className="bg-white rounded-lg">
      <div style={{ width: "100%" }} className="h-[300px] md:h-[400px]">
        <ResponsiveContainer>
          <AreaChart
            data={data}
            margin={{
              top: 10,
              right: 30,
              left: 0,
              bottom: 20,
            }}
          >
            {/* Definisi untuk warna gradient */}
            <defs>
              <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#34D399" stopOpacity={0.45} />
                <stop offset="95%" stopColor="#34D399" stopOpacity={0.05} />
              </linearGradient>
            </defs>

            {/* Sumbu X dengan padding atas (tickMargin) */}
            <XAxis
              dataKey="date"
              stroke="gray"
              axisLine={false}
              tickLine={false}
              tickMargin={20}
              tick={{ fontSize: 10 }}
            />

            {/* Sumbu Y tanpa garis sumbu dan garis tick */}
            <YAxis
              stroke="gray"
              axisLine={false}
              tickLine={false}
              tickMargin={10}
              tick={{ fontSize: 12 }}
            />

            {/* Garis grid di background dibuat solid (tidak putus-putus) */}
            <CartesianGrid stroke="#f0f0f0" vertical={false} strokeWidth={2} />

            <Tooltip
              formatter={(value) => `${formatCurrency(value)} USDT`}
              labelFormatter={(label) => (
                <div className="text-xs">Date: {label}</div>
              )}
              contentStyle={{
                fontSize: "12px",
                borderRadius: "8px",
                padding: "8px",
              }}
            />
            {/* Area grafik */}
            <Area
              type="monotone"
              dataKey="profit"
              stroke="#34D399" // Warna garis
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorValue)" // Menggunakan gradient yang telah didefinisikan
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

// Anda bisa mengimpor dan menggunakan komponen ini di file lain seperti App.js
// Contoh:
// import { ProfitTrendsChart } from './ProfitTrendsChart';
//
// function App() {
//   return (
//     <div className="p-10 bg-gray-100 min-h-screen">
//       <ProfitTrendsChart />
//     </div>
//   );
// }
